import 'twin.macro';
import React from 'react';

import { Container } from '../atoms';
import { Collapse } from '../elements';

const Questions = ({ faqOption = [] }) => (
  <Container tw="bg-white">
    <div tw="max-w-7xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8">
      <div tw="max-w-3xl mx-auto divide-y-2 divide-gray-200">
        {faqOption &&
          faqOption.map((item) => {
            if (!item) return null;
            return (
              <Collapse title={item.question} key={item.id}>
                {item.description}
              </Collapse>
            );
          })}
      </div>
    </div>
  </Container>
);

export default Questions;
